import { create } from 'zustand';

interface UIState {
    showOnboarding: boolean;
    setShowOnboarding: (show: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
    showOnboarding: false,
    setShowOnboarding: (show) => set({ showOnboarding: show }),
}));
